import React from "react";
import axios from 'axios';
import {
  getCustomer,
  listCustomers,
  customerByBusinessByPhone,
} from 'graphql/queries'
import {
  createChangelog,
  deleteCustomerCoupon,
} from 'graphql/mutations';
import {
  onCreateCustomer,
  onUpdateCustomer,
} from 'graphql/subscriptions';
import { diff } from 'json-diff';
import {API, graphqlOperation} from '@aws-amplify/api'
import {Auth} from '@aws-amplify/auth'
import {Actions as NOTIFICATIONACTIONS} from 'store/notifications/action';
import { Actions as COUPONACTIONS } from "store/coupon/action";
import parsePhoneNumber from 'libphonenumber-js'
import parsePhoneNumberFromString from 'libphonenumber-js'
import { REST_API } from '../../constants';

const { format } = require('date-fns')

// types of action
const Types = {
  CUSTOMER_GET_ITEM: "CUSTOMER_GET_ITEM",
  CUSTOMER_UPDATE_ITEM: "CUSTOMER_UPDATE_ITEM",
  CUSTOMER_CREATE_ITEM: "CUSTOMER_CREATE_ITEM",
  CUSTOMER_DELETE_ITEM: "CUSTOMER_DELETE_ITEM",
  CUSTOMER_CLEAR_ITEM: "CUSTOMER_CLEAR_ITEM",
  CUSTOMER_LOADING: "CUSTOMER_LOADING",
  CUSTOMER_GET_LIST: "CUSTOMER_GET_LIST",
  CUSTOMER_GET_SEARCH: "CUSTOMER_GET_SEARCH",
  CUSTOMER_NEW_MODAL: "CUSTOMER_NEW_MODAL",
  CUSTOMER_NEW_COUPON: "CUSTOMER_NEW_COUPON",
  CUSTOMER_DELETE_CUPOM: "CUSTOMER_DELETE_CUPOM",
};

const newCustomerModal =  (show) => ({
  type: Types.CUSTOMER_NEW_MODAL,
  show
});

const dispatchLoading =  loading => ({
  type: Types.CUSTOMER_LOADING,
  loading
});

const clearItem = response => ({
  type: Types.CUSTOMER_CLEAR_ITEM
});

const dispatchGetItem = response => ({
  type: Types.CUSTOMER_GET_ITEM,
  payload: response
});

const newCoupon =  (coupon,  customer) => ({
  type: Types.CUSTOMER_NEW_COUPON,
  payload: { coupon, customer },
});

const deletedCoupon =  (id) => ({
  type: Types.CUSTOMER_DELETE_CUPOM,
  payload: id,
});

const getItem = (id) => {
  console.log('getItem1',getItem)
  return (dispatch, getState) => {
    dispatch(dispatchLoading(true))

    const variables = {id}
    const request = API.graphql({query: getCustomer, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})
    console.log('getItem2',getItem)
    request.then((response) => {
        dispatch(dispatchGetItem(response))
        dispatch(dispatchLoading(false))
    });
    
  }
}

const dispatchUpdateItem = (response,callback) => ({
  type: Types.CUSTOMER_UPDATE_ITEM,
  payload: response,
  callback
});

const updateItem = (item,callback) => {
  return (dispatch, getState) => {
    const state = getState()
    if (item.phone){
      let phone = item.phone.startsWith("00") ? "+" + item.phone.substr(2) : item.phone;
      phone = parsePhoneNumberFromString(phone)
      if (!phone) phone = parsePhoneNumber(item.phone,"MT")
      item.phone = phone.number
    }
    const businessID = state.businessID; 
    const currentCustomer = state.customer && state.customer.item
    const body = { customer: {...item, businessID} }
    axios({
      method: `put`,
      url: `/customer`,
      data: body,
      baseURL: REST_API,
    })
    .then(async (response) => {
      if (response?.data?.customer?.errors) {
        dispatch(
          NOTIFICATIONACTIONS.addNotification(
            {
              title: <React.Fragment>Error</React.Fragment>,
              message: `Error updating user`,
              icon: `error`,
            },
            3000
          )
        );
        return;
      }
        
      const updatedCustomer = response?.data?.customer;
      
      if (callback && typeof(callback == 'function')) callback(updatedCustomer)
      
      const difference = diff(currentCustomer,updatedCustomer);

      // remove common items
      delete difference._version;
      delete difference._lastChangedAt;
      delete difference.updatedAt;
      delete difference.queue;
      delete difference.bookings;
      delete difference.reviewEmailSent;
      delete difference.finalReminderSent;
      delete difference.confirmationReminderSent;

      console.log('difference',difference)

      const userInfo = await Auth.currentUserInfo();
      console.log('userInfo',userInfo)

      const currentTeamMember = state.teamMember.list.find(i => i.username == userInfo.username)

      const newChangeLog = {
        entityID: item.id,
        action: "Update",
        teamMemberID: currentTeamMember.id,
        businessID: state.businessID,
        diff: JSON.stringify(difference)
      }

      const changeLogRequest = API.graphql({query: createChangelog, variables: {input: newChangeLog}, authMode: "AMAZON_COGNITO_USER_POOLS"})

      changeLogRequest.then((response) => {
        console.log('changeLogSaved',response)
        // we don't need to do anythign after saving the changelog right now.
      })

        //TODO Plan notification logic/errors
      dispatch(NOTIFICATIONACTIONS.addNotification({
        title: <React.Fragment><strong>{updatedCustomer.givenName}</strong> has been updated</React.Fragment>,
        message: `You can book this customer`,
        icon: `success`,
      }, 3000));
    })
    .catch((error) => {
      const { data } = error?.response;
      dispatch(NOTIFICATIONACTIONS.addNotification({
        title: <React.Fragment>Error</React.Fragment>,
        message: `${data?.error || "Error updating user"}`,
        icon: `error`,
      }, 3000));
  });
  }
}

const dispatchDeleteItem = response => ({
  type: Types.CUSTOMER_DELETE_ITEM,
  payload: response
});

const deleteItem = (id, history) => {
  return (dispatch, getState) => {
    axios({
      method: `delete`,
      url: `/customer/${id}`,
      baseURL: REST_API,
    })
    .then((response) => {
      // go to main page as it's been deleted
      history.push(`/customer`); 
      dispatch(dispatchDeleteItem(id));
      dispatch(NOTIFICATIONACTIONS.addNotification({
        title: <React.Fragment>Customer has been deleted</React.Fragment>,
        message: `This customer is no longer available.`,
        icon: `success`,
      }, 3000));
    })
    .catch((error) => {
      const { data } = error?.response;
      dispatch(NOTIFICATIONACTIONS.addNotification({
        title: <React.Fragment>Error</React.Fragment>,
        message: `${data?.error || "Error deleting customer"}`,
        icon: `error`,
      }, 3000));
    });
  }
}

const dispatchCreateItem = (response,callback) => ({
  type: Types.CUSTOMER_CREATE_ITEM,
  payload: response,
  callback
});

const createItem = (item,callback) => {
  return (dispatch, getState) => {
    let phone = parsePhoneNumberFromString(item.phone);
    if (!phone) phone = parsePhoneNumber(item.phone, "MT");
    item.phone = phone.number;

    const state = getState();
    const businessID = state.businessID;
    const body = { customer: { ...item, businessID } };

    axios({
      method: `post`,
      url: `/customer`,
      data: body,
      baseURL: REST_API,
    })
    .then((response) => {
      const createdCustomer = response?.data?.customer;
      if (!createdCustomer) {
        return dispatch(NOTIFICATIONACTIONS.addNotification({
          title: <React.Fragment>Unable to create user. Please try again later.</React.Fragment>,
          icon: `error`,
        }, 5000))
      }
      if (callback && typeof(callback == 'function')) callback(createdCustomer)

      dispatch(NOTIFICATIONACTIONS.addNotification({
        title: <React.Fragment><strong>{createdCustomer?.givenName}</strong> has been saved</React.Fragment>,
        icon: `success`,
      }, 5000))
    }).catch((error) => {
      console.error("[create Customer]", error)
      return dispatch(
        NOTIFICATIONACTIONS.addNotification(
          {
            title: <React.Fragment>Error</React.Fragment>,
            message: `${ error?.response?.status == 409 ? "Phone already used" : "Error creating user" }`,
            icon: `warning`,
          },
          5000
        )
      );
    });  
  }
}

const updateList = response => ({
  type: Types.CUSTOMER_GET_LIST,
  payload: response
});

const getList = (limit, nextToken) => {
  return (dispatch, getState) => {

    const today = format(new Date(),"yyyy-MM-dd")

    const variables = {filter: { active: { ne: false } }, limit, nextToken, today}
    const request = API.graphql({query: listCustomers, variables, authMode: "AMAZON_COGNITO_USER_POOLS"})

    request.then((response) => {
        dispatch(updateList(response))
    });
    
  }
}

const saveCouponToCustomer = (customerCoupon, coupon, customer) => {
  return (dispatch, getState) => {
    axios({
      method: `post`,
      url: `/customerCoupon`,
      data: { customerCoupon },
      baseURL: REST_API,
    })
      .then(async (response) => {
        const createCustomerCoupon = response.data;
      if (createCustomerCoupon)
        dispatch(newCoupon({ id: createCustomerCoupon?.id, _version: createCustomerCoupon?._version, coupon }, customer))
      else {
        dispatch(
          NOTIFICATIONACTIONS.addNotification(
            {
              title: <React.Fragment>Error</React.Fragment>,
              message: `Error saving coupon to customer`,
              icon: `warning`,
            },
            5000
          )
        )
      }
    });
  };
};

const bulkSaveCouponToCustomer = (customerPhoneNumbers, couponID) => {
  return (dispatch, getState) => {
    const state = getState();
    const businessID = state.businessID;
    return axios({
      method: `post`,
      url: `/customerCoupon/bulk`,
      data: { customerPhoneNumbers, couponID, businessID },
      baseURL: REST_API,
    })
      .then(async (response) => {
        const customerCouponRes = response.data;
        const notFoundorFailedPhoneNumbers = response.data.notFoundorFailedPhoneNumbers;
        if (customerCouponRes.success) {
          dispatch(
            NOTIFICATIONACTIONS.addNotification(
              {
                title: <React.Fragment>Saved</React.Fragment>,
                message: <React.Fragment>
                  {notFoundorFailedPhoneNumbers?.length > 0 ? (
                    <span className="flex flex-col">
                      <span> The following numbers were not found or failed: </span>
                      {notFoundorFailedPhoneNumbers.map((number, index) => (
                        <span key={index}>{number}</span>
                      ))}
                    </span>
                  ) : (
                    <span className="flex">
                      <span>Coupons have been added to the customers.</span>
                    </span>
                  )}
                </React.Fragment>
                ,
                icon: `success`,
              }
            )
          )
          return true;
        }
        else
          throw new Error();
      })
      .catch((error) => {
        console.error("[bulkSaveCouponToCustomer]", error)
        return dispatch(
          NOTIFICATIONACTIONS.addNotification(
            {
              title: <React.Fragment>Error</React.Fragment>,
              message: `${error?.response?.data?.error || `Error saving coupon to customers`}`,
              icon: `warning`,
            },
            5000
          )
        );
      })
      .finally(() => {
        dispatch(COUPONACTIONS.getItem(couponID));
      });
  };
};

const sendDeleteCustomerCoupon = (id) => {
  return (dispatch, getState) => {
    axios({
      method: `delete`,
      url: `/customerCoupon/${id}`,
      baseURL: REST_API,
    })
    .then(async (response) => {
      const deleteCustomerCoupon = response.data;
      if (deleteCustomerCoupon.success)
        dispatch(deletedCoupon(id));
      else {
        dispatch(
          NOTIFICATIONACTIONS.addNotification(
            {
              title: <React.Fragment>Error</React.Fragment>,
              message: `Error revoking coupon`,
              icon: `warning`,
            },
            5000
          )
        )
      }
    })
    .catch((error) => {
      return dispatch(
        NOTIFICATIONACTIONS.addNotification(
          {
            title: <React.Fragment>Error</React.Fragment>,
            message: `${ error?.response?.status?.toString()?.startsWith('4') ? error?.response?.data?.error : "Error revoking coupon" }`,
            icon: `warning`,
          },
          5000
        )
      );
    });
  };
};

const subscribeToUpdates = () => {
  return (dispatch, getState) => {

    const state = getState()

    const businessID = state.businessID

    const createSubscription = API.graphql(
        graphqlOperation(onCreateCustomer,{businessID})
    ).subscribe({
        next: (data) => {

          const newEntry = data.value.data.onCreateCustomer;

          let currentCustomer = state.customer && state.customer.list && state.customer.list.find(({id}) => id == newEntry.id)
          
          if (!currentCustomer){
            dispatch(dispatchCreateItem(data.value))
          }
          console.log('onCreateCustomer',data.value)
        }
    });

    const updateSubscription = API.graphql(
        graphqlOperation(onUpdateCustomer,{businessID})
    ).subscribe({
        next: (data) => {

          const newEntry = data.value.data.onUpdateCustomer;
          let currentCustomer = state.customer && state.customer.list && state.customer.list.find(({id}) => id == newEntry.id)

          if (!currentCustomer || currentCustomer._version != newEntry._version){
            console.log('onUpdateCustomer',data.value)
            dispatch(dispatchUpdateItem(data.value))
          }
        }
    });

  }
}

const Actions = {
  getItem,
  createItem,
  updateItem,
  deleteItem,
  getList,
  clearItem,
  newCustomerModal,
  subscribeToUpdates,
  saveCouponToCustomer,
  sendDeleteCustomerCoupon,
  bulkSaveCouponToCustomer,
}

export {Types, Actions}